import { Component, OnInit } from '@angular/core';
import { CommonConstants } from './../common/utilities/commonConstants';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { HomeService } from './home.service';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { RouteHandlerService } from './../common/services/routeHandler.service';
import { SharedService } from './../common/services/sharedService';
import { ActivitiHandlerService } from './../common/services/activitiHandler.service';
import { Formatter } from './../common/services/formatter';
import { EmitterService } from './../common/services/emitter.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { adobe_analytics_service } from '../common/services/adobe_analytics_service';
import { HttpClientModule } from '@angular/common/http';
@Component({
    selector: 'app-home',
    template: '',
    styleUrls: ['./home.style.scss'],
    providers: [HomeService, HttpClientModule]
})
export class HomeComponent implements OnInit {
    private _UTMDataObject: any;
    public RedirectionRequired: Boolean = true;
    public ApplicationDetails: any;
    public OfferApplicationDetails: any;
    public bflJourney: boolean;
    constructor(
        private _homeService: HomeService,
        private _routeContextProvider: RouteContextProvider,
        private _cookieHandler: CookieHandlerService,
        private _sharedService: SharedService,
        private _routerService: RouteHandlerService,
        private _formatter: Formatter,
        private _activitiHandler: ActivitiHandlerService,
        private _emitterService: EmitterService,
        private _sessionHandlerService: SessionHandlerService,
        private _adobe_analytics_service: adobe_analytics_service
    ) {
        this.bflJourney = this._sharedService.isBFLJourney();
    }

    public initiateAuthentication() {
        console.log('initiateAuthentication...');
        this.setMobileValues();
        this._sharedService.setData(CommonConstants.QueryParamsKeys.InsuranceProductType,
            this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.InsuranceProductType));
        this._sharedService.setData(CommonConstants.QueryParamsKeys.InsuranceProductType,
            this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.InsuranceProductType) ||
            this._routeContextProvider.GetQueryParams(CommonConstants.CookieKeys.InsProductType));
        this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.InsProductType]);
        const InsProductType = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.InsuranceProductType) ||
            this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.InsProductType);
        if (InsProductType) {
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.InsProductType, InsProductType);
        }
        this.utmSourceStamping();
        // offer specific code
        if (this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ApplicantId)) {
            this.CreateRequestForOffer();
            this.CreateApplicationRequest(this.OfferApplicationDetails, (response) => {
                console.log('RESPONSE==', response);
            });
        } else {
            if (!this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken)) {
                this.authenticateSystem();
            }
            this._routerService.RouteToNextTask('getGoingNow');
        }
    }

    public ngOnInit(): void {
        this.initiateAuthentication();
    }

    private CreateRequestForOffer() {
        this.OfferApplicationDetails = {
            'insuranceProductType': this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.InsProductType),
            'insuranceApplications': {
                'insProduct': CommonConstants.LOAN_PRODUCT_CODES.HealthCombo_Insurance
            },
            'applicantId': this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ApplicantId),//resp.payload.applicantId,
            'applicationId': this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ApplicationId),//resp.payload.applicationId,
            'applicationApplicantId': this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ApplicationApplicantId), //resp.payload.applicationApplicantId,
            'resumeJourney': false,
        };
        this._sharedService.setData(CommonConstants.QueryParamsKeys.ApplicantId,
            this._routeContextProvider.GetQueryParams
                (CommonConstants.QueryParamsKeys.ApplicantId));
        this._sharedService.setData(CommonConstants.QueryParamsKeys.ApplicationId,
            this._routeContextProvider.GetQueryParams
                (CommonConstants.QueryParamsKeys.ApplicationId));
        this._sharedService.setData(CommonConstants.QueryParamsKeys.ApplicationApplicantId,
            this._routeContextProvider.GetQueryParams
                (CommonConstants.QueryParamsKeys.ApplicationApplicantId));
        this.storeDetailsToCookies();
    }
    // this checks if user should be ab tested or not?
    private initProcess(callback: Function) {
        this.startActivitiWithApplicationCreate(
            (mtResponse: ActivitiModel.MTResponse<any>) => {
                callback(mtResponse);
            });
    }
    public startActivitiWithApplicationCreate(
        onSuccessCallback: Function,
        applicationDetails?: any) {
        const startActivitiRequest: any = {
            activitiName: 'startFlow',
            payload: this.ApplicationDetails
        };
        console.log(startActivitiRequest);
        this.startActiviti(startActivitiRequest, onSuccessCallback);
    }
    public CreateApplicationRequest(applicationRequest: any, cb?: Function) {
        this._emitterService.changeMessage(true);
        this.ApplicationDetails = applicationRequest;
        this.initProcess((responseDataObj) => {
            this._activitiHandler.MarkTaskAsCompleted(null, 'Manual', true)
                .subscribe((resp: any) => {
                    const mtResponse = resp;
                    this._emitterService.changeMessage(false);
                    if (!mtResponse.errorBean) {
                        this._routerService.RouteToNextTask(mtResponse.nextTaskKey);
                    } else {
                        this._emitterService.changeMessage(false);
                        console.log('Error Occured on ', mtResponse.errorBean);
                        cb(mtResponse);
                    }
                },
                    (error) => {
                        console.log(error);
                        cb(() => { error });
                    });
        });
    }
    private startActiviti(request: any, onSuccessCallback: Function) {
        this._activitiHandler.StartActiviti(request, true)
            .subscribe((response: ActivitiModel.MTResponse<any>) => {
                console.log('Raw Activiti working now');
                const data = response;
                if (!data.errorBean) {
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ProcessInstanceDetails,
                        data.payload.processInstanceDetails);
                    onSuccessCallback(data);
                }
            },
                (Error) => {
                    console.log(Error);
                });
    }
    public authenticateSystem(): void {
        this.setSystemAuthToken(CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance);
    }
    private setSystemAuthToken(productCode): void {
        const epToken = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.JWTokenEP);
        const sourceType = this._routeContextProvider.GetQueryParams('sourceType');
        let useEpToken: boolean;
        if (this.bflJourney) {
            if (epToken && sourceType == "empPortal") {
                useEpToken = true;
            } else {
                useEpToken = false;
            }
        } else {
            if (epToken) {
                useEpToken = true;
            } else {
                useEpToken = false;
            }
        }
        if (useEpToken) {
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, epToken);
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardKey, this._cookieHandler.GetCookie(CommonConstants.CookieKeys.GuardKeyEP));
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken, this._formatter
                .ConvertGuradKeyToGuardToken(this._cookieHandler.GetCookie(CommonConstants.CookieKeys.GuardTokenEP)));
        } else {
            this._homeService.GetSystemAuthToken({
                productCode
            }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
                if (!responseData.errorBean) {
                    const tokenObj = responseData.payload.tokens[0];
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, tokenObj.token);
                    if (this._routeContextProvider.GetQueryParams
                        (CommonConstants.QueryParamsKeys.IsMobile) === '1') {
                        const psuedoVerifiedToken = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.PSVToken);
                        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, psuedoVerifiedToken);
                    } else {
                        const psuedoVerifiedToken = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken);
                        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, psuedoVerifiedToken);
                    }
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken, this._formatter
                        .ConvertGuradKeyToGuardToken(tokenObj.guardKey));

                } else {
                }
            });
        }
    }
    private storeDetailsToCookies() {
        const appId = this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicationId);
        if (appId) {
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.LoanApplicationId, appId);
            this._cookieHandler.SetCookie(CommonConstants.CookieKeys.LoanApplicationId, appId, appId);
        }
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.LoanApplicationKey,
            this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicationApplicantId));
    }
    private setMobileValues() {
        this._emitterService.Get(CommonConstants.EmitterEventTypes.MobileAppCheck)
            .emit(this._routeContextProvider.GetQueryParams
                (CommonConstants.QueryParamsKeys.IsMobile));
        // Set Mobile cookie
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.MobileState,
            this._routeContextProvider.GetQueryParams
                (CommonConstants.QueryParamsKeys.IsMobile));
    }
    utmSourceStamping() {
        const src_90 = this._routeContextProvider.GetQueryParams('src_90');
        const src_60 = this._routeContextProvider.GetQueryParams('src_60');
        const src_30 = this._routeContextProvider.GetQueryParams('src_30');
        const pid = this._routeContextProvider.GetQueryParams('pid');
        const source = this._routeContextProvider.GetQueryParams('utm_source');
        const medium = this._routeContextProvider.GetQueryParams('utm_medium');
        const campaign = this._routeContextProvider.GetQueryParams('utm_campaign');
        const content = this._routeContextProvider.GetQueryParams('utm_content');
        const term = this._routeContextProvider.GetQueryParams('utm_term');
        const utmType = src_90 ? 'src_90' : src_60 ? 'src_60' : src_30 ? 'src_30' : pid ? 'pid' : 'utm';
        let utm = '';
        if ((source || medium || campaign || content || term) && utmType === 'utm') {
            utm = ['', source, medium, campaign, content, term].join(':');
        }
        console.log('source', source, 'medium', medium);

        this._sessionHandlerService.SetSession('UTM', src_90 || src_60 || src_30 || pid || utm);
        this._sessionHandlerService.SetSession('UtmType', utmType);
        this._sharedService.setData('UTM', src_90 || src_60 || src_30 || pid || utm);
        this._sharedService.setData('UtmType', utmType);
    }
}
